import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  AutoSizer,
  Column,
  SortDirection,
  SortIndicator,
  Table,
} from "react-virtualized";
import { AdminActions } from "../../actions/adminActions";
import { ServerActions } from "../../actions/serverActions";
import { adminStore } from "../../stores/adminStore";
import { subdivisionStore } from "../../stores/subdivision";
import { AdminHeader } from "./adminHeader";
import { AdminInputRow } from "./adminInputRow";
import { AdminRow } from "./adminRow";

import "../../css/adminScreen.css";
import { withRouter } from "../../util/withRouter";
let adminTimerInterval = null;

//Load state from the stores
function getStateFromStores() {
  return {
    itemType: adminStore.getItemType(),
    isLoading: adminStore.isLoading(),
    items: adminStore.getItems(),
    loadingError: adminStore.getError(),
    subdivisions: subdivisionStore.getEntireSubList(),
    disableHeader: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortBy: "name",
    sortDirection: SortDirection.ASC,
    filteredData: adminStore.getItems(),
    seqNo: "",
    trackName: "",
    oldSeqNo: 0,
    oldTrackName: "",
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
  };
}

const AdminPageComponent = createReactClass({
  componentDidMount: function () {
    adminStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    AdminActions.setItemType(this.props.location.pathname);
    AdminActions.loadItems();
    ServerActions.getSubdivisionList();
    adminTimerInterval = setInterval(this.refresh, 1000);
  },

  componentWillUnmount: function () {
    adminStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    clearInterval(adminTimerInterval);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  refresh: function () {
    this.setState({});
  },
  //Sort function for the default track data table
  _sort({ sortBy, sortDirection }) {
    const comparer = (a, b) => {
      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.filteredData.sort(comparer);

    this.setState({ rows });
    this.setState({ sortBy, sortDirection });
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },
  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  },
  _onRowCountChange(event) {
    const rowCount = parseInt(event.target.value, 10) || 0;

    this.setState({ rowCount });
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },

  _onScrollToRowChange(event) {
    const { rowCount } = this.state;
    let scrollToIndex = Math.min(
      rowCount - 1,
      parseInt(event.target.value, 10)
    );

    if (isNaN(scrollToIndex)) {
      scrollToIndex = undefined;
    }

    this.setState({ scrollToIndex });
  },

  _getRowHeight({ index }) {
    const { list } = this.context;

    return this._getDatum(list, index).size;
  },

  _updateUseDynamicRowHeight(value) {
    this.setState({
      useDynamicRowHeight: value,
    });
  },
  //Filter the records form the Default track table
  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.items;
    console.log("dataset", dataSet)
    dataSet = dataSet.filter(function (item) {
      if (
        (item.gritDfltTrkNme || "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.gritDfltTrkSeqNbr + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  },

  _headerRenderer({ dataKey, sortBy, sortDirection }) {
    return (
      <div>
        Display Order
        {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
      </div>
    );
  },
  //Save New Default Track Record
  saveNewDefaultTrack: function () {
    var state = this.state;
    if (parseInt(state.seqNo) <= 0) {
      this.setState({ alertVisible: true });
      this.setState({
        alertMessage: "Please enter positive number in Display Order field ",
      });
    } else if (isNaN(parseInt(state.seqNo))) {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please fill out Display Order field" });
    } else if (state.trackName == "") {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please fill out Track Name field" });
    } else {
      AdminActions.submitNewDefaultTrack({
        gritDfltTrkSeqNbr: state.seqNo,
        gritDfltTrkNme: state.trackName,
        oldSeqNo: state.oldSeqNo,
        oldTrackName: state.oldTrackName,
        gritDfltTrkId: state.defaultID,
      });
      setTimeout(
        function () {
          AdminActions.loadItems();
          items: adminStore.getItems();
          var dataSet = this.state.items;
          this.setState({ filteredData: dataSet });
        }.bind(this),
        150
      );
    }
  },
  //clear selected track
  clearSelectedTrack: function () {
    this.setState({
      oldSeqNo: "",
      oldTrackName: "",
      defaultID: 0,
      seqNo: "",
      trackName: "",
    });
  },
  handleAlertDismiss() {
    this.setState({ alertVisible: false });
  },

  deleteSelectedTrack: function () {
    var state = this.state;
    if (state.defaultID == "") {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please select a row to delete" });
    } else {
      window
        .confirm("Confirm Delete", {
          description:
            "Are you sure you want to delete the selected track ? Track Name: " +
            state.trackName,
          confirmLabel: "Delete",
          abortLabel: "Go Back",
        })
        .then(function () {
          AdminActions.deleteDefaultTrack(state.defaultID);
          setTimeout(
            function () {
              AdminActions.loadItems();
              items: adminStore.getItems();
              var dataSet = this.state.items;
              this.setState({ filteredData: dataSet });
            }.bind(this),
            150
          );
        });
    }
  },

  _onRowClick({ rowData }) {
    this.setState({
      oldTrackName: rowData.gritDfltTrkNme,
      oldSeqNo: rowData.gritDfltTrkSeqNbr,
      seqNo: rowData.gritDfltTrkSeqNbr,
      trackName: rowData.gritDfltTrkNme,
      defaultID: rowData.gritDfltTrkId,
    });
  },

  onChange: function (event) {
    if (event.target) {
      //update the reactJs state for typing
      if (event.target.id == "name") {
        this.setState({ trackName: event.target.value });
      } else {
        this.setState({ seqNo: event.target.value });
      }
    }
  },

  render: function () {
    var errorMsg = "";
    if (this.state.alertVisible) {
      errorMsg = (
        <Modal
          bsSize="large"
          dialogClassName="errorModal"
          onHide={this.handleAlertDismiss}
          show={this.state.alertVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>

          <div className="modal-body">{this.state.alertMessage}</div>
          <div className="modal-footer">
            {/*<Button id="confirmSubmitButton" bsStyle='danger' onClick={onConfirm}>{confirmText}</Button>*/}
            <Button id="cancelConfirmButton" onClick={this.handleAlertDismiss}>
              OK
            </Button>
          </div>
        </Modal>
      );
    }
    var sequence = this.state.seqNo;
    var trackNames = this.state.trackName;
    var seqNo = (
      <div className="addEditTopRow">
        <label>*Display Order:</label>
      </div>
    );
    var seqNoField = (
      <div className="addEditTopRow">
        <input
          type="number"
          id="seq"
          className="mpInput"
          name="Display Order"
          maxLength="5"
          value={sequence}
          onChange={this.onChange}
          required
        />
      </div>
    );
    var trackName = (
      <div className="addEditTopRow">
        <label>*Track Name:</label>
      </div>
    );
    var trackNameField = (
      <div className="addEditTopRow">
        <input
          type="text"
          id="name"
          className="mpInput"
          name="Track Name"
          maxLength="20"
          value={trackNames}
          style={{ width: "175px" }}
          onChange={this.onChange}
          required
        />
      </div>
    );
    var addButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.saveNewDefaultTrack}
        >
          Save
        </Button>
      </div>
    );

    var clearButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.clearSelectedTrack}
        >
          Clear
        </Button>
      </div>
    );

    var deleteButton = (
      <div>
        <Button
          bsStyle="danger adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.deleteSelectedTrack}
        >
          Delete
        </Button>
      </div>
    );
    const {
      disableHeader,
      useDynamicRowHeight,
      scrollToIndex,
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
    } = this.state;

    var rows = this.state.items.map(
      function (item, i) {
        return (
          <AdminRow type={this.state.itemType} rowNum={i} key={i} item={item} />
        );
      }.bind(this)
    );

    var content = "Loading....";

    if (this.state.isLoading) {
      content = "Loading....";
    } else {
      if (this.state.itemType == "/defaultTracks") {
        var list = this.state.filteredData;

        content = (
          <div style={{ height: "100%" }}>
            <table width="100%">
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  <div className="screenHeader">
                    <b>Default Track</b>
                  </div>
                  <div id="accordion" className="ui-widget-header">
                    <h5>
                      <b>ADD/EDIT RECORD</b>
                    </h5>
                  </div>
                  <div id="controlLayoutGrid" role="main">
                    <table id="headers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="2%;" />
                          <th align="center" width="9%;">
                            {seqNo}
                          </th>
                          <th align="center" width="6%;">
                            {seqNoField}
                          </th>
                          <th align="center" width="8%;">
                            {trackName}
                          </th>
                          <th id="th4" width="15%;">
                            {trackNameField}
                          </th>
                          <th align="center" width="35%;" />
                        </tr>
                      </thead>
                    </table>
                    <table id="footers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="40%;" />
                          <th align="center" width="6%;">
                            {addButton}
                          </th>
                          <th align="center" width="6%;">
                            {clearButton}
                          </th>
                          <th align="center" width="8%;">
                            {deleteButton}
                          </th>
                          <th align="center" width="40%;" />
                        </tr>
                      </thead>
                    </table>
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  <div id="accordion" className="ui-widget-TableHeader">
                    <span>
                      <b>Search: </b>
                    </span>
                    <input
                      type="text"
                      onChange={(event) =>
                        this._filterRecordsOfTheTable(event.target.value)
                      }
                    />
                  </div>
                  <div style={{ height: "65vh" }}>
                    <AutoSizer>
                      {({ height, width }) => (
                        <Table
                          ref="Table"
                          disableHeader={disableHeader}
                          headerClassName="headerColumn"
                          scrollToIndex={scrollToIndex}
                          width={width}
                          height={height}
                          headerHeight={headerHeight}
                          overscanRowCount={overscanRowCount}
                          rowHeight={
                            useDynamicRowHeight ? this._getRowHeight : rowHeight
                          }
                          rowCount={list.length}
                          rowClassName={this._rowClassName}
                          noRowsRenderer={this._noRowsRenderer}
                          sort={this._sort}
                          sortBy={sortBy}
                          sortDirection={sortDirection}
                          onRowDoubleClick={this._onRowClick}
                          rowGetter={({ index }) => list[index]}
                        >
                          <Column
                            width={width * 0.18}
                            minWidth={150}
                            label="Display Order"
                            dataKey="gritDfltTrkSeqNbr"
                            headerRenderer={this._headerRenderer}
                          />
                          <Column
                            width={width * 0.82}
                            minWidth={200}
                            label="Track Name"
                            dataKey="gritDfltTrkNme"
                          />
                          <Column width={0} dataKey="id" />
                        </Table>
                      )}
                    </AutoSizer>
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
            </table>
          </div>
        );
      } else {
        content = (
          <table striped bordered condensed hover responsive>
            <thead>
              <AdminHeader type={this.state.itemType} />
              <AdminInputRow
                type={this.state.itemType}
                subdivisions={this.state.subdivisions}
              />
            </thead>
            <tbody>{rows}</tbody>
          </table>
        );
      }
    }

    return (
      <div className="positionUnderHeader" style={{ height: "100%" }}>
        {content}
        {errorMsg}
      </div>
    );
  },
});
export const AdminPage = withRouter(AdminPageComponent);